if (!String.prototype.format) {
  String.prototype.format = function (...rest) {
    return this.replace(/{(\d+)}/g, function (match, number) {
      return typeof rest[number] != 'undefined' ? rest[number] : match
    })
  }
}
